<div class="card">
  <div class="card-header">
    <h1>Asociar Compras con Órdenes de Compra</h1>
  </div>

  <div class="card-body">
    <div class="mb-3 d-flex gap-3 align-items-end flex-wrap">
      <div class="text-muted">
        <i class="fa fa-circle-info"></i>
        Selecciona una <b>compra</b> a la izquierda y marca las <b>órdenes</b> a asociar a la derecha.
        Una orden solo puede estar asociada a una sola compra.
      </div>
    </div>

    <div class="row">
      <svg id="svg-container" #svgContainer></svg>

      <!-- Tabla de Compras (lado izquierdo) -->
      <div class="col">
        
        <div class="form-group">
          <label class="form-label">Buscar compra</label>
          <input type="text" [(ngModel)]="filterPurchases" (input)="debouncedFilterPurchases()"
                 class="form-control" placeholder="Serie-Número de compra / proveedor" />

          <div class="mb-3 row">
            <div class="col-md-6">
              <label class="form-label">Fecha inicio</label>
              <input type="date" class="form-control" [(ngModel)]="startDate" (change)="loadPurchases()" />
            </div>
            <div class="col-md-6">
              <label class="form-label">Fecha fin</label>
              <input type="date" class="form-control" [(ngModel)]="endDate" (change)="loadPurchases()" />
            </div>
          </div>
        </div>

        <h5 class="mt-2">Compras NO asociadas</h5>
        <div class="table-responsive mt-3">
          <table class="table table-bordered" id="table-purchases-not-associated">
            <thead>
              <tr>
                <th></th>
                <th>Número</th>
                <th>Proveedor</th>
                <th>Fecha</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let p of purchasesNotAssociated"
                  [attr.data-id]="p.id"
                  (click)="selectPurchase(p.id)"
                  [class.selected]="p.id === selectedPurchaseId">
                <td>
                  <i [ngClass]="p.id === selectedPurchaseId ? 'fa-solid fa-circle' : 'fa-regular fa-circle'"></i>
                </td>
                <td>{{ p.number }}</td>
                <td>{{ p.providerName }}</td>
                <td>{{ p.date | date:'yyyy-MM-dd' }}</td>
                <td>{{ p.total | number:'1.2-2' }}</td>
              </tr>
              <tr *ngIf="purchasesNotAssociated.length === 0">
                <td colspan="5" class="text-muted text-center">
                  <i class="fa fa-circle-info"></i> No hay compras no asociadas.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <app-simple-pagination
          id="purchases-not-associated-pag"
          [sizes]="[5,10,20]"
          (changed)="selectedPurchaseId = null; refreshPurchasesPaginationNotAssociated()"
          [elements]="paginationPurchasesNotAssociated">
        </app-simple-pagination>

        <hr class="my-4">

        <!-- TABLA DE COMPRAS ASOCIADAS -->
        <h5 class="mt-2">Compras asociadas</h5>
        <div class="table-responsive mt-3">
          <table class="table table-bordered" id="table-purchases-associated">
            <thead>
              <tr>
                <th></th>
                <th>Número</th>
                <th>Proveedor</th>
                <th>Fecha</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let p of purchasesAssociated"
                  [attr.data-id]="p.id"
                  (click)="selectPurchase(p.id)"
                  [class.selected]="p.id === selectedPurchaseId">
                <td>
                  <i [ngClass]="p.id === selectedPurchaseId ? 'fa-solid fa-circle' : 'fa-regular fa-circle'"></i>
                </td>
                <td>{{ p.number }}</td>
                <td>{{ p.providerName }}</td>
                <td>{{ p.date | date:'yyyy-MM-dd' }}</td>
                <td>{{ p.total | number:'1.2-2' }}</td>
              </tr>
              <tr *ngIf="purchasesAssociated.length === 0">
                <td colspan="5" class="text-muted text-center">
                  <i class="fa fa-circle-info"></i> No hay compras asociadas.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <app-simple-pagination
          id="purchases-associated-pag"
          [sizes]="[5,10,20]"
          (changed)="selectedPurchaseId = null; refreshPurchasesPaginationAssociated()"
          [elements]="paginationPurchasesAssociated">
        </app-simple-pagination>
      </div>

      <!-- Tabla de Órdenes (lado derecho) -->
      <div class="col">
        <div class="form-group">
          <label class="form-label">Buscar orden</label>
          <input type="text" [(ngModel)]="filterOrders" (input)="debouncedFilterOrders()"
                 class="form-control" placeholder="Número de orden / proveedor" />
        </div>

        <div class="table-responsive mt-3">
          <table class="table table-bordered" id="table-orders">
            <thead>
              <tr class="tr-middle">
                <th></th>
                <th>Número</th>
                <th>Proveedor</th>
                <th>Fecha</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let o of orders"
                  [attr.data-id]="o.id"
                  (click)="toggleOrder(o)"
                  [class.selected]="currentRelatedOrderIds.includes(o.id)"
                  [class.disabled]="isOrderLocked(o)">
                <td>
                  <i *ngIf="!isOrderLocked(o)"
                     [ngClass]="currentRelatedOrderIds.includes(o.id) ? 'fa-solid fa-circle' : 'fa-regular fa-circle'"></i>
                  <i *ngIf="isOrderLocked(o)" class="fa-solid fa-lock"></i>
                </td>
                <!-- <td>{{ o.number }}</td> -->
                <td class="relative">
                  {{ o.number }}

                  <span *ngIf="o.enteredIntoInventory" class="indicator"></span>
                </td>
                <td>{{ o.providerName }}</td>
                <td>{{ o.date | date:'yyyy-MM-dd' }}</td>
              </tr>

              <tr *ngIf="orders.length === 0">
                <td colspan="4" class="text-muted">
                  <i class="fa fa-circle-info"></i> No se encontraron órdenes.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <app-simple-pagination
          id="orders-pag"
          [sizes]="[5,10,20]"
          (changed)="refreshOrdersPagination()"
          [elements]="paginationOrders">
        </app-simple-pagination>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col"  *ngIf="currentPurchases">
        <h5>Detalles de la compra</h5>
        <table class="table table-bordered" id="table-orders">
          <thead>
            <tr class="tr-middle">
              <th>Código</th>
              <th>Nombre</th>
              <th class="">Cantidad</th>
              <th class="">Precio U</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let purchases of currentPurchases">
              <td>{{ purchases.productData.code }}</td>
              <td>{{ purchases.productData.name }}</td>
              <td>{{ purchases.quantity }}</td>
              <td>{{ purchases.price.toFixed(2) }}</td>
            </tr>

            <tr *ngIf="currentPurchases.length === 0">
              <td colspan="5" class="text-muted">
                <i class="fa fa-circle-info"></i> No se encontraron órdenes.
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col" *ngIf="currentRelatedOrderIds && currentRelatedOrderIds.length > 0">
        <h5>Detalles de la(s) orden(es)</h5>
        <table class="table table-bordered">
          <thead>
            <tr class="tr-middle">
              <th>Código</th>
              <th>Nombre</th>
              <th>Cantidad</th>
              <th>Costo</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let detail of currentOrderDetails">
              <td>{{ detail.productData.code }}</td>
              <td>{{ detail.productData.name }}</td>
              <td>{{ detail.quantity }}</td>
              <td>{{ detail.cost }}</td>
            </tr>

            <tr *ngIf="!currentOrderDetails || currentOrderDetails.length === 0">
              <td colspan="4" class="text-muted">
                <i class="fa fa-circle-info"></i> No se encontraron detalles de órdenes.
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div *ngIf="selectedPurchaseId" class="d-flex align-items-center mt-3">

        <div class="form-check form-switch m-0" *ngIf="showTransformationSwitch">
          <input
            class="form-check-input"
            type="checkbox"
            id="switchTransformation"
            [(ngModel)]="transformation"
            (ngModelChange)="onTransformationToggle()"
            [disabled]="loading"
          />
          <label class="form-check-label" for="switchTransformation">
            <div class="fw-semibold">Transformación</div>
            <small class="text-muted">
              Se transformará el producto de la factura de compra en el enrutado configurado.
            </small>
          </label>
        </div>

        <button class="btn btn-info ms-auto" [disabled]="getDisabledSave() || loading" (click)="showModal = true">
          <ng-container *ngIf="!loading">
            <i class="fa fa-floppy-disk"></i>
          </ng-container>
          <ng-container *ngIf="loading">
            <span class="spinner-border spinner-border-sm"></span>
          </ng-container>
          FINALIZAR Y GUARDAR
        </button>
      </div>
    </div>
  </div>
</div>


<app-modal-dialog [show]="showModal" #modal [size]="'md'">
  <div class="modal-header" modal-header>
      <h4>Alerta de Asociacion de Compra con ordenes</h4>
      <h4 class="i-hover ml-4">
          <i class="fa fa-xmark" (click)="closeModal(modal)"></i>
      </h4>
  </div>
  <div class="modal-body" modal-body>
    <div>
      <p>
        Una vez que asocies una compra con una o más órdenes de compra, no podrás modificar estas asociaciones posteriormente desde este módulo.
      </p>
      <p *ngIf="transformation">
        Recuerda presionaste el boton de transformación, por lo que se transformará el producto de la factura de compra en el enrutado configurado.
      </p>
    </div>
    <div class="d-flex flex-row justify-end gap-4">
      <button class="btn btn-secondary" (click)="closeModal(modal)">CANCELAR</button>
      <button class="btn btn-danger" (click)="saveAssociation(true)">CONFIRMAR Y CONTINUAR</button>
    </div>
  </div>
</app-modal-dialog>